import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceStatusEnum } from 'models/enums/invoice-status.enum';
import { TypeSalesSupportActions } from 'models/enums/types-sales-support-actions.enum';
import { SalesSupportActionsAttributeFilter } from '../../../models/sales-support-actions-attribute-filter';

@Component({
  selector: 'jhi-sales-support-actions-attribute-filter',
  templateUrl: './sales-support-actions-attribute-filter.component.html',
  styleUrls: ['./sales-support-actions-attribute-filter.component.scss'],
})
export class SalesSupportActionsAttributeFilterComponent {
  @Input() filter!: SalesSupportActionsAttributeFilter;
  @Output() filterChange = new EventEmitter<SalesSupportActionsAttributeFilter>();
  InvoiceStatus = InvoiceStatusEnum;
  public readonly TypeSalesSupportActions = TypeSalesSupportActions;
}
